import script from "./EnrollLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./EnrollLayout.vue?vue&type=script&setup=true&lang=js"

import "./EnrollLayout.vue?vue&type=style&index=0&id=f8e6b452&scoped=true&lang=css"

import exportComponent from "/Users/lidonglei/Documents/project/Dean_DHSES/dean_dhses_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f8e6b452"]])

export default __exports__